/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { getEntities as getVaccinations } from 'app/entities/vaccination/vaccination.reducer';
import { getEntities as getVaccinationScheduleDetails } from 'app/entities/vaccination-schedule-details/vaccination-schedule-details.reducer';
import { createEntity, getEntity, reset, updateEntity } from './user-vaccination-schedule-details.reducer';

export const UserVaccinationScheduleDetailsUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const vaccinations = useAppSelector(state => state.vaccination.entities);
  const vaccinationScheduleDetails = useAppSelector(state => state.vaccinationScheduleDetails.entities);
  const userVaccinationScheduleDetailsEntity = useAppSelector(state => state.userVaccinationScheduleDetails.entity);
  const loading = useAppSelector(state => state.userVaccinationScheduleDetails.loading);
  const updating = useAppSelector(state => state.userVaccinationScheduleDetails.updating);
  const updateSuccess = useAppSelector(state => state.userVaccinationScheduleDetails.updateSuccess);

  const handleClose = () => {
    navigate(`/user-vaccination-schedule-details${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getGlucoUsers({}));
    dispatch(getVaccinations({}));
    dispatch(getVaccinationScheduleDetails({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.givenDate !== undefined && typeof values.givenDate !== 'number') {
      values.givenDate = Number(values.givenDate);
    }
    values.lastModifiedDt = convertDateTimeToServer(values.lastModifiedDt);
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.periodInDays !== undefined && typeof values.periodInDays !== 'number') {
      values.periodInDays = Number(values.periodInDays);
    }
    if (values.recDateMax !== undefined && typeof values.recDateMax !== 'number') {
      values.recDateMax = Number(values.recDateMax);
    }
    if (values.recDateMin !== undefined && typeof values.recDateMin !== 'number') {
      values.recDateMin = Number(values.recDateMin);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...userVaccinationScheduleDetailsEntity,
      ...values,
      glucoUser: glucoUsers.find(it => it.id.toString() === values.glucoUser?.toString()),
      vaccination: vaccinations.find(it => it.id.toString() === values.vaccination?.toString()),
      scheduleDetails: vaccinationScheduleDetails.find(it => it.id.toString() === values.scheduleDetails?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          lastModifiedDt: displayDefaultDateTime(),
        }
      : {
          ...userVaccinationScheduleDetailsEntity,
          lastModifiedDt: convertDateTimeFromServer(userVaccinationScheduleDetailsEntity.lastModifiedDt),
          glucoUser: userVaccinationScheduleDetailsEntity?.glucoUser?.id,
          vaccination: userVaccinationScheduleDetailsEntity?.vaccination?.id,
          scheduleDetails: userVaccinationScheduleDetailsEntity?.scheduleDetails?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="tinyMedicRestApp.userVaccinationScheduleDetails.home.createOrEditLabel"
            data-cy="UserVaccinationScheduleDetailsCreateUpdateHeading"
          >
            <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.home.createOrEditLabel">
              Create or edit a UserVaccinationScheduleDetails
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="user-vaccination-schedule-details-id"
                  label={translate('tinyMedicRestApp.userVaccinationScheduleDetails.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.userVaccinationScheduleDetails.active')}
                id="user-vaccination-schedule-details-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userVaccinationScheduleDetails.dosage')}
                id="user-vaccination-schedule-details-dosage"
                name="dosage"
                data-cy="dosage"
                type="text"
                validate={{
                  maxLength: { value: 20, message: translate('entity.validation.maxlength', { max: 20 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userVaccinationScheduleDetails.givenDate')}
                id="user-vaccination-schedule-details-givenDate"
                name="givenDate"
                data-cy="givenDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userVaccinationScheduleDetails.lastModifiedDt')}
                id="user-vaccination-schedule-details-lastModifiedDt"
                name="lastModifiedDt"
                data-cy="lastModifiedDt"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userVaccinationScheduleDetails.microSec')}
                id="user-vaccination-schedule-details-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userVaccinationScheduleDetails.periodInDays')}
                id="user-vaccination-schedule-details-periodInDays"
                name="periodInDays"
                data-cy="periodInDays"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userVaccinationScheduleDetails.recDateMax')}
                id="user-vaccination-schedule-details-recDateMax"
                name="recDateMax"
                data-cy="recDateMax"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userVaccinationScheduleDetails.recDateMin')}
                id="user-vaccination-schedule-details-recDateMin"
                name="recDateMin"
                data-cy="recDateMin"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userVaccinationScheduleDetails.risk')}
                id="user-vaccination-schedule-details-risk"
                name="risk"
                data-cy="risk"
                type="text"
                validate={{
                  maxLength: { value: 20, message: translate('entity.validation.maxlength', { max: 20 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userVaccinationScheduleDetails.timestampentry')}
                id="user-vaccination-schedule-details-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userVaccinationScheduleDetails.vaccinationTypeCd')}
                id="user-vaccination-schedule-details-vaccinationTypeCd"
                name="vaccinationTypeCd"
                data-cy="vaccinationTypeCd"
                type="text"
                validate={{
                  maxLength: { value: 150, message: translate('entity.validation.maxlength', { max: 150 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userVaccinationScheduleDetails.lastupdated')}
                id="user-vaccination-schedule-details-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userVaccinationScheduleDetails.completionStatus')}
                id="user-vaccination-schedule-details-completionStatus"
                name="completionStatus"
                data-cy="completionStatus"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 50, message: translate('entity.validation.maxlength', { max: 50 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userVaccinationScheduleDetails.cursor')}
                id="user-vaccination-schedule-details-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userVaccinationScheduleDetails.batchNumber')}
                id="user-vaccination-schedule-details-batchNumber"
                name="batchNumber"
                data-cy="batchNumber"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <UncontrolledTooltip target="batchNumberLabel">
                <Translate contentKey="tinyMedicRestApp.userVaccinationScheduleDetails.help.batchNumber" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.userVaccinationScheduleDetails.serialNumber')}
                id="user-vaccination-schedule-details-serialNumber"
                name="serialNumber"
                data-cy="serialNumber"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                id="user-vaccination-schedule-details-glucoUser"
                name="glucoUser"
                data-cy="glucoUser"
                label={translate('tinyMedicRestApp.userVaccinationScheduleDetails.glucoUser')}
                type="select"
                required
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="user-vaccination-schedule-details-vaccination"
                name="vaccination"
                data-cy="vaccination"
                label={translate('tinyMedicRestApp.userVaccinationScheduleDetails.vaccination')}
                type="select"
                required
              >
                <option value="" key="0" />
                {vaccinations
                  ? vaccinations.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="user-vaccination-schedule-details-scheduleDetails"
                name="scheduleDetails"
                data-cy="scheduleDetails"
                label={translate('tinyMedicRestApp.userVaccinationScheduleDetails.scheduleDetails')}
                type="select"
                required
              >
                <option value="" key="0" />
                {vaccinationScheduleDetails
                  ? vaccinationScheduleDetails.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/user-vaccination-schedule-details"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default UserVaccinationScheduleDetailsUpdate;
